import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function PalindromeChecker() {
    const [script, setScript] = useLocalStorage('fixPalindromeCheckerScript', `function isPalindrome(str) {
    return str === str.split('').reverse().join('');
}
    `);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');

    const testCases = [
        { input: "level", expected: true },
        { input: "test", expected: false },
        { input: "A man, a plan, a canal, Panama", expected: true },
        { input: "racecar", expected: true },
        { input: "hello", expected: false }
    ];

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');

        try {
            const results = testCases.map(({ input }) => {
                const scriptFunction = new Function(`
                    function print(text) {
                        return text;
                    }
                    ${script}
                    return isPalindrome(${JSON.stringify(input)});
                `);
                return { input, result: scriptFunction() };
            });

            const formattedOutput = results.map(({ input, result }) =>
                `<div><strong>${input}:</strong> ${result}</div>`
            ).join('');
            setSrcDoc(`<!DOCTYPE html><html><body>${formattedOutput}</body></html>`);

            checkPassed(results.map(r => r.result));
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText('Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:');
            setErrorMessage(e.message);
            setSrcDoc(`<!DOCTYPE html>
                <html>
                <head><style>body { font-family: Arial, sans-serif; color: red; }</style></head>
                <body><div>Fehler: ${e.message}</div></body>
                </html>`);
        }
    }

    function checkPassed(results) {
        const isCorrect = results.every((result, index) => result === testCases[index].expected);

        if (isCorrect) {
            setResultTextCss('success-result');
            setResultText("Deine Lösung ist korrekt!");
        } else {
            setResultTextCss('error-message');
            setResultText("Deine Lösung ist leider falsch. Bitte überprüfe deinen Code und versuche es erneut.");
        }
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>Kaputter Palindrom-Checker</h2>
                Deine Aufgabe ist es, eine Funktion zu reparieren, die überprüft, ob ein Wort oder ein Satz ein Palindrom ist.
                Momentan funktioniert die Überprüfung nicht korrekt, da Groß-/Kleinschreibung und Satzzeichen nicht berücksichtigt werden.
                <br/><br/>
                Anforderungen:
                <ul>
                    <li>Die Funktion muss Groß-/Kleinschreibung ignorieren.</li>
                    <li>Alle nicht-alphanumerischen Zeichen sollen entfernt werden.</li>
                </ul>
                Sobald du deinen Code implementiert hast, kannst du ihn ausführen, um zu sehen, ob die Überprüfung korrekt ist.
            </div>

            <div className="aufgaben-container">
                <GroupEditor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="fixPalindromeCheckerScript"
                />
            </div>

            <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>

            <div className="ergebnis-text">
                Ergebnis: <br/>
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>

            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="40%"
                />
            </div>
        </>
    );
}

export default PalindromeChecker;
